/* global MediaStreamTrack */
'use strict';

if (typeof MediaStreamTrack !== 'undefined') {
  module.exports = MediaStreamTrack;
} else {
  module.exports = function MediaStreamTrack() {
    throw new Error('WebRTC is not supported in this browser');
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/webrtc/lib/mediastreamtrack.js
// module id = HNQF
// module chunks = 0